module.exports = __webpack_public_path__ + "mq.svg?48cd7ba9bfecc363cb4e9dba75236b87";